export const golarionCalendar = {
  name: 'Gregorian',
  months: [
    {
      name: 'Abadius',
      days: 31,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Calistril',
      days: 28,
      leapDays: 1,
      leapPeriod: 8,
    },
    {
      name: 'Pharast',
      days: 31,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Gozran',
      days: 30,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Desnus',
      days: 31,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Sarenith',
      days: 30,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Erastus',
      days: 31,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Arodus',
      days: 31,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Rova',
      days: 30,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Lamashan',
      days: 31,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Neth',
      days: 30,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Kuthona',
      days: 31,
      leapDays: 0,
      leapPeriod: 0,
    },
  ],
  time: {
    minute: {
      name: 'Minute',
      plural: 'Minutes',
      duration: '60',
    },
    hour: {
      name: 'Hour',
      plural: 'Hours',
      duration: '3600',
    },
    day: {
      name: 'Day',
      plural: 'Days',
      duration: '86400',
    },
    month: {
      name: 'Month',
      plural: 'Months',
    },
    year: {
      name: 'Year',
      plural: 'Years',
      duration: '31536000',
    },
    decade: {
      name: 'Decade',
      plural: 'Decades',
      enabled: true,
      duration: '315360000',
    },
    century: {
      name: 'Century',
      plural: 'Centuries',
      enabled: true,
      duration: '3153600000',
    },
    millenium: {
      name: 'Millenium',
      plural: 'Millenia',
      enabled: true,
      duration: '31536000000',
    },
    myriad: {
      name: 'Myriad',
      plural: 'Myriads',
      enabled: true,
      duration: '315360000000',
    },
    epoch: {
      name: 'Epoch',
      plural: 'Epochs',
      enabled: true,
      duration: '3153600000000',
    },
    aeon: {
      name: 'Aeon',
      plural: 'Aeons',
      enabled: true,
      duration: '31536000000000',
    },
  },
  days: {
    showWeekDays: true,
    weekLength: 7,
    weekdays: [
      { name: 'Moonday', abbr: 'Moo', order: 0, weekend: false },
      { name: 'Toilday', abbr: 'Toi', order: 1, weekend: false },
      { name: 'Wealday', abbr: 'Wea', order: 2, weekend: false },
      { name: 'Oathday', abbr: 'Oat', order: 3, weekend: false },
      { name: 'Fireday', abbr: 'Fir', order: 4, weekend: false },
      { name: 'Starday', abbr: 'Sta', order: 5, weekend: false },
      { name: 'Sunday', abbr: 'Sun', order: 6, weekend: true },
    ],
    globalHolidays: [
      { name: 'New Year', day: 1, month: 0 },
      { name: 'Vault Day', day: 6, month: 0 },
      { name: 'Merrymead', day: 2, month: 1 },
      { name: 'Loyalty Day', day: 19, month: 1 },
      { name: 'Day of Bones', day: 5, month: 2 },
      { name: 'Currentseve', day: 7, month: 3 },
      { name: 'Taxfest', day: 15, month: 3 },
      { name: 'Ascendance Night', day: 2, month: 4 },
      { name: 'Azvadeva Dejal', day: 3, month: 4 },
      { name: 'Old-Mage Day', day: 13, month: 4 },
      { name: 'Angel Day', day: 31, month: 4 },
      { name: 'Day of Destiny', day: 3, month: 5 },
      { name: 'Liberty Day', day: 3, month: 5 },
      { name: 'Burning Blades', day: 10, month: 5 },
      { name: 'Talon Tag', day: 21, month: 5 },
      { name: 'Riverwind Festival', day: 22, month: 5 },
      { name: "Archer's Day", day: 3, month: 6 },
      { name: 'Founding Festival', day: 14, month: 6 },
      { name: 'Kianidi Festival', day: 15, month: 6 },
      { name: 'Kianidi Festival', day: 16, month: 6 },
      { name: 'Kianidi Festival', day: 17, month: 6 },
      { name: 'Burning Night', day: 17, month: 6 },
      { name: 'Kianidi Festival', day: 18, month: 6 },
      { name: 'Kianidi Festival', day: 19, month: 6 },
      { name: 'Kianidi Festival', day: 20, month: 6 },
      { name: 'Kianidi Festival', day: 21, month: 6 },
      { name: "Inheritor's Ascendance", day: 1, month: 7 },
      { name: 'First Crusader Day', day: 6, month: 7 },
      { name: 'Day of Silenced Whispers', day: 9, month: 7 },
      { name: 'Founding Day', day: 10, month: 7 },
      { name: 'Armasse', day: 16, month: 7 },
      { name: "St. Alika's Birthday", day: 31, month: 7 },
      { name: 'Autumnal Carpentry Court', day: 16, month: 8 },
      { name: 'Autumnal Carpentry Court', day: 17, month: 8 },
      { name: 'Autumnal Carpentry Court', day: 18, month: 8 },
      { name: 'Day of the Inheritor', day: 19, month: 8 },
      { name: 'Autumnal Carpentry Court', day: 19, month: 8 },
      { name: 'Autumnal Carpentry Court', day: 20, month: 8 },
      { name: 'Autumnal Carpentry Court', day: 21, month: 8 },
      { name: 'Autumnal Carpentry Court', day: 22, month: 8 },
      { name: 'Autumnal Carpentry Court', day: 23, month: 8 },
      { name: 'Autumnal Carpentry Court', day: 24, month: 8 },
      { name: 'Autumnal Carpentry Court', day: 25, month: 8 },
      { name: 'Feast of Szurpade', day: 26, month: 8 },
      { name: 'Autumnal Carpentry Court', day: 26, month: 8 },
      { name: 'Autumnal Carpentry Court', day: 27, month: 8 },
      { name: 'Autumnal Carpentry Court', day: 28, month: 8 },
      { name: 'Day of Sundering', day: 29, month: 8 },
      { name: 'Autumnal Carpentry Court', day: 29, month: 8 },
      { name: 'Ascendance Day', day: 6, month: 9 },
      { name: 'Kraken Carnival', day: 15, month: 9 },
      { name: 'Bastion Day', day: 19, month: 9 },
      { name: 'Bastion Day', day: 20, month: 9 },
      { name: 'Jestercap', day: 27, month: 9 },
      { name: 'Allbirth', day: 30, month: 9 },
      { name: 'Festival of the Witch', day: 30, month: 9 },
      { name: 'Independence Day', day: 5, month: 10 },
      { name: 'Seven Veils', day: 7, month: 10 },
      { name: 'Abjurant Day', day: 8, month: 10 },
      { name: 'Great Fire Remembrance', day: 13, month: 10 },
      { name: 'Even-Tongued Day', day: 14, month: 10 },
      { name: 'Evoking Day', day: 18, month: 10 },
      { name: 'Seven Veils', day: 23, month: 10 },
      { name: 'Baptism of Ice', day: 24, month: 10 },
      { name: 'Baptism of Ice', day: 25, month: 10 },
      { name: 'Baptism of Ice', day: 26, month: 10 },
      { name: 'Baptism of Ice', day: 27, month: 10 },
      { name: 'Transmutatum', day: 28, month: 10 },
      { name: 'Baptism of Ice', day: 28, month: 10 },
      { name: 'Baptism of Ice', day: 29, month: 10 },
      { name: 'Baptism of Ice', day: 30, month: 10 },
      { name: 'The Shadowchaining', day: 1, month: 11 },
      { name: 'Pseudodragon Festival', day: 7, month: 11 },
      { name: 'Ascendance Day (Cayden Cailean)', day: 11, month: 11 },
      { name: 'Winterbloom', day: 15, month: 11 },
      { name: 'The Final Day', day: 31, month: 11 },
      { name: 'Night of the Pale', day: 31, month: 11 },
      { name: 'Turning Day', day: 31, month: 11 },
    ],
  },
};
